import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-class-joined-success',
  templateUrl: './class-joined-success.component.html',
  styleUrls: ['./class-joined-success.component.css']
})

export class ClassJoinedSuccessComponent implements OnInit {
  username: string;
  pairId: string;
  className: string;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.username = params['username'];
      this.pairId = params['pairId'];
      this.className = params['className'];
  });    
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/class-joined-success/class-joined-success.component.ts